import { makeStyles } from '@material-ui/core';

export const useApBottomSheetStyles = makeStyles((theme) => ({
  root: {
    padding: 0,
    [theme.breakpoints.down('sm')]: {
      alignItems: 'flex-end',
    },
  },

  paper: {
    borderRadius: theme.spacing(2),
    minHeight: '40%',
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.colors.global.Neutral_850
        : theme.colors.Background_Primary,

    [theme.breakpoints.down('sm')]: {
      borderRadius: theme.spacing(2, 2, 0, 0),
      margin: 0,
      maxWidth: '100%',
      width: '100%',
      height: '100%',
      maxHeight: `calc(100% - ${theme.spacing(5)}px)`,
    },
  },

  contentRoot: {
    padding: theme.spacing(1, 2),

    '&.fullHeight > div': {
      height: '100%',
    },

    [theme.breakpoints.up('md')]: {
      '&.noOverflow': {
        overflow: 'hidden',
      },
    },
  },

  bottomContent: {
    padding: theme.spacing(0, 2),
  },

  bottomDescription: {
    margin: theme.spacing(1, 0, 2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: theme.spacing(0, 0, 1, 1),
    flexDirection: 'column',
  },
  topDescription: {
    marginBottom: theme.spacing(2),
  },

  actionsRoot: {
    margin: theme.spacing(1, 0),
    padding: theme.spacing(1, 2),
    flexDirection: 'column',
    width: '100%',
  },

  buttonRoot: {
    width: '100%',
    borderRadius: '8px',
    '&:nth-of-type(2)': {
      margin: theme.spacing(1, 'auto', 0),
    },
  },

  closeIcon: {
    alignSelf: 'flex-end',
    padding: theme.spacing(2, 2.25),
    cursor: 'pointer',
    fontSize: theme.spacing(2),
    color: theme.colors.Text_1,
    position: 'absolute',
    zIndex: 99,
  },
}));
